const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgClassify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nuevos i\u0301conos 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57,80a13.52,13.52,0,0,1,12.76,9.07L70,89l.52,0h27A4.5,4.5,0,0,1,98,98l-.52,0h-27a4.74,4.74,0,0,1-.75-.06,13.51,13.51,0,0,1-25.51,0L44,98l-.52,0h-27A4.5,4.5,0,0,1,16,89l.52,0h27a4.74,4.74,0,0,1,.75.06A13.5,13.5,0,0,1,57,80Zm0,9a4.5,4.5,0,1,0,4.5,4.5A4.49,4.49,0,0,0,57,89ZM25.5,48.5a13.52,13.52,0,0,1,12.76,9.07l.22,0,.52,0H97.5a4.5,4.5,0,0,1,.52,9l-.52,0H39a4.74,4.74,0,0,1-.75-.06A13.5,13.5,0,1,1,25.5,48.5Zm0,9A4.5,4.5,0,1,0,30,62,4.49,4.49,0,0,0,25.5,57.5ZM75,17a13.52,13.52,0,0,1,12.76,9.07L88,26l.52,0h9A4.5,4.5,0,0,1,98,35l-.52,0h-9a4.74,4.74,0,0,1-.75-.06,13.51,13.51,0,0,1-25.51,0L62,35l-.52,0h-45A4.5,4.5,0,0,1,16,26l.52,0h45a4.74,4.74,0,0,1,.75.06A13.5,13.5,0,0,1,75,17Zm0,9a4.5,4.5,0,1,0,4.5,4.5A4.49,4.49,0,0,0,75,26Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassify);
export default __webpack_public_path__ + "static/media/classify.c08874c6bec24786878302609bb988ff.svg";
export { ForwardRef as ReactComponent };